import { SET_UNREAD_TOPICS_COUNT } from './actions';

export default {
    [SET_UNREAD_TOPICS_COUNT]: (state, payload) => {
        state.unreadTopicsCount = payload;
    },
};
